 

export  const commonCategoryProps = {
  title: 'Category',
  titleCn: '分类',
  valueKeys: "categories",
};